import { render, staticRenderFns } from "./SlideCopy.vue?vue&type=template&id=f89720c6&scoped=true&"
import script from "./SlideCopy.vue?vue&type=script&lang=js&"
export * from "./SlideCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89720c6",
  null
  
)

export default component.exports